/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
// Type for async functions
// Type for things that may be items, may be asynchronous
export let AbAsyncUtils;
(function (_AbAsyncUtils) {
  const isAsyncFunc = _AbAsyncUtils.isAsyncFunc = item => {
    return typeof item === "function";
  };
  const isCalculatedFunc = _AbAsyncUtils.isCalculatedFunc = item => {
    return typeof item === "function";
  };
  const mapItem = _AbAsyncUtils.mapItem = (item, callback) => {
    if (isAsyncFunc(item)) return () => item().then(callback);
    return callback(item);
  };
  const resolve = _AbAsyncUtils.resolve = async item => {
    if (isCalculatedFunc(item)) return await item();
    return item;
  };
})(AbAsyncUtils || (AbAsyncUtils = {}));
//# sourceMappingURL=AbAsyncUtils.js.map
